import React, { useEffect, useState } from "react";
import { TextField, InputLabel, Button } from "@material-ui/core";

const CreateFlagModal = ({
  handleClose,
  handleTitleChange,
  handleCommentChange,
  handleApply,
  flagTitle,
  flagComment,
}) => {
  const [readyToSave, setReadyToSave] = useState(false);

  useEffect(() => {
    if (!flagTitle) {
      setReadyToSave(false);
    } else {
      setReadyToSave(true);
    }
  }, [flagTitle]);

  return (
    <React.Fragment>
      <div className="flags-modal-header">Create bookmark</div>
      <div className="flags-modal-content">
        <div className="mt-1r">
          <InputLabel id="flag-title">Title</InputLabel>
          <div className="mt-05r">
            <TextField
              id="flag-title"
              variant="outlined"
              autoFocus
              value={flagTitle}
              onChange={handleTitleChange}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: "20rem" }}
            />
          </div>
        </div>
        <div className="mt-1r">
          <InputLabel id="flag-title">Comment</InputLabel>
          <div className="mt-05r">
            <TextField
              id="flag-comment"
              variant="outlined"
              value={flagComment}
              multiline
              rows={4}
              onChange={handleCommentChange}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: "20rem" }}
            />
          </div>
        </div>
        <div className="mt-1r">
          <Button
            onClick={handleApply}
            variant="contained"
            color="primary"
            className="mr-1r"
            disabled={!readyToSave}
          >
            Save
          </Button>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Cancel
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateFlagModal;
